import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AdvertenciaCierreDialog(props) {

    const handleClose = () => {
        props.onClose()
    };

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Advertencia de cierre accidental de Omnichannel</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Estás desactivando la advertencia de cierre accidental de Omnichannel. <br />
                        Con esta acción estás aceptando la responsabilidad ante la pérdida de datos que existiera por falta de control de la sesión y presencia en la aplicación
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Entendido
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}